import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTableComponent from "../../components/DataTable";
import {
  deleteUserManagementData,
  fetchUserManagementData,
} from "../../redux/slice/UserManagementSlice";
import icon from "../../Assets/Profile/profileicon/Icon.png";
import Loader from "../../components/Common/Loader/PrimaryLoader";
import { useNavigate } from "react-router-dom";
import InfoModal from "../../components/Common/InfoModal";
import { toast } from "react-toastify";
import DeleteConFirmationModal from "../../components/Common/DeleteConFirmationModal";
import UpdateUserStatusModal from "../../components/Common/UpdateUserStatusModal";
import Swal from "sweetalert2";
import { inviteViaEmail } from "../../redux/slice/CreateNewUserSlice";
import { RxTriangleDown } from "react-icons/rx";
import { usePic } from "../../context/PicProvider";
import { successStatusCode } from "../../utils/constants";

function Users() {
  const [userListModal, setUserListModal] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [confirmUpdateModal, setConfirmUpdateModal] = useState(false);
  const [modalConfirmTitle, setModalConfirmTitle] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [showDropCon, setShowDropCon] = useState(false);
  const [downDrop, setDownDrop] = useState(false);
  const [customClass, setCustomClass] = useState("");
  const [removeId, setRemoveId] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsLoading } = usePic();
  const { status, UserManagementData } = useSelector(
    (state) => state.USERMANAGEMENT
  );

  const userStatusUpdateHandler = async (id) => {
    toast.success("User Status Updated Successfully");
    setConfirmUpdateModal(false);
    setDeleteConfirm(false);
  };
  // const clickRowHandler = (row) => {
  //   setUserInfo(row);
  //   setUserListModal(true);
  // };
  const clickRowHandler = (row) => {
    // Redirect to the "update-user" page with the respective ID
    navigate(`/update-user/${row._id}`);
  };

  const onSelectedCheckboxChange = (check) => {
    const selectedId = check?.selectedRows.map((curElm) => curElm._id);
    if (selectedId.length > 0) {
      setRemoveId(selectedId);
      setShowDropCon(true);
    } else {
      setRemoveId([]);
      setShowDropCon(false);
    }
  };

  const downIconHandler = () => {
    setDownDrop(!downDrop);
  };

  const removeUserHandler = async () => {
    setIsLoading(true);
    const result = await dispatch(
      deleteUserManagementData({ userIds: removeId })
    );
    setIsLoading(false);
    const res = result?.payload;
    if (res?.status === successStatusCode) {
      dispatch(fetchUserManagementData());
      setDeleteConfirm(false);
      setShowDropCon(false);
      setDownDrop(false);
      setRemoveId([]);
    }
  };

  const deleteHandler = () => {
    setDeleteConfirm(true);
    setModalConfirmTitle("Are you sure you want to delete this user ?");
  };

  const handleCustomClassForUnderLine = (num) => {
    setCustomClass(num);
  };

  useEffect(() => {
    dispatch(fetchUserManagementData());
  }, [dispatch]);

  const userColumns = [
    {
      name: "",
      selector: (row) => (
        <img
          src={row.profile_pic ? row.profile_pic : icon}
          alt={row.lastName}
          className="products-image"
        />
      ),
      width: "90px",
    },
    {
      name: (
        <span
          className={`${
            customClass === "2" ? "custom-span-style-for-sorting" : ""
          } text-nowrap`}
          onClick={() => handleCustomClassForUnderLine("2")}
        >
          First Name
        </span>
      ),
      selector: (row) => row.first_name,
      sortable: true,
    },
    {
      name: (
        <span
          className={`${
            customClass === "1" ? "custom-span-style-for-sorting" : ""
          } text-nowrap`}
          onClick={() => handleCustomClassForUnderLine("1")}
        >
          Last Name
        </span>
      ),
      selector: (row) => row.last_name,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "3" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("3")}
        >
          Job Title
        </span>
      ),
      selector: (row) => row.job_title,
      sortable: true,
    },
    {
      name: (
        <span
          className={customClass === "4" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("4")}
        >
          Location
        </span>
      ),
      selector: (row) => row.location_name,
      sortable: true,
    },
    // {
    //   name: (
    //     <span
    //       className={customClass === "5" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("5")}
    //     >
    //       Area
    //     </span>
    //   ),
    //   selector: (row) => row.area,
    //   sortable: true,
    // },
    // {
    //   name: (
    //     <span
    //       className={customClass === "6" ? "custom-span-style-for-sorting" : ""}
    //       onClick={() => handleCustomClassForUnderLine("6")}
    //     >
    //       Role
    //     </span>
    //   ),
    //   selector: (row) => row.assigned_role,
    //   sortable: true,
    // },
    {
      name: (
        <span
          className={customClass === "6" ? "custom-span-style-for-sorting" : ""}
          onClick={() => handleCustomClassForUnderLine("6")}
        >
          Role
        </span>
      ),
      selector: (row) => {
        if (row.assigned_role === "rm_superadmin") {
          return "Super Admin";
        } else if (row.assigned_role === "admin") {
          return "Admin";
        } else if (row.assigned_role === "approver") {
          return "Approver";
        } else if (row.assigned_role === "approver") {
          return "Approver";
        } else if (row.assigned_role === "user") {
          return "User";
        } else if (row.assigned_role === "salesrepresentative") {
          return "Sales Executive";
        } else if (row.assigned_role === "distributor_salesrepresentative") {
          return "Sales Executive";
        } else if (row.assigned_role === "rm_admin") {
          return "Admin";
        } else {
          return row.assigned_role; // Return the original role if it doesn't match any condition
        }
      },
      sortable: true,
    },

    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div className="d-flex d-none">
    //       <NavLink
    //         className={"btn btn-sm btn-info me-2"}
    //         to={`/update-user/${row._id}`}
    //       >
    //         <FaEdit/>
    //       </NavLink>
    //       <button
    //         className={"btn btn-sm btn-danger"}
    //         onClick={() => removeUserHandler(row._id)}
    //       >
    //         <FaRegTrashAlt />
    //       </button>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Invite",
    //   selector: (row) => (
    //     <button
    //       className="btn btn-sm btn-primary"
    //       onClick={() => handleInvite(row)}
    //     >
    //       Invite
    //     </button>
    //   ),
    //   ignoreRowClick: true, // Prevent row selection when clicking this button
    //   buttonContentClasses: "btn btn-sm btn-primary", // Button classes
    //   width: "100px", // Width of the column
    // },
  ];

  const handleInvite = (row) => {
    Swal.fire({
      title: "Send Invitation?",
      text: `Send an invitation link to ${row.email}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Send Email",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleOkButtonClick(row.email);
      }
    });
  };

  const handleOkButtonClick = async (email) => {
    const response = await dispatch(inviteViaEmail({ email }));
    if (response.payload.status === 200) {
      Swal.fire(
        "Email Sent",
        "Confirmation email has been sent successfully!",
        "success"
      );
    } else {
      Swal.fire(
        "Failed to Send Email",
        "An error occurred while sending the email",
        "error"
      );
    }
  };

  if (status === "loading") {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  const userData = UserManagementData || [];

  return (
    <div className=" position-relative flex-grow-1">
      {userData && userData.length > 0 && showDropCon && (
        <div className="dropdown_icon_style">
          <div onClick={() => downIconHandler()}>
            <RxTriangleDown size={23} />
          </div>
          {downDrop && (
            <div className="event-box-data-user-event-listing">
              <h6 className="cursor" onClick={() => deleteHandler()}>
                Delete{" "}
              </h6>
              {/* <h6 className="cursor mt-1" onClick={() => statusHandler()}>
                Disable/Enable{" "}
              </h6> */}
            </div>
          )}
        </div>
      )}
      <DataTableComponent
        search={true}
        searchBy={["email", "first_name", "job_title"]}
        title={"Team Management"}
        columns={userColumns}
        data={userData}
        selectedRows
        clickedRow={clickRowHandler}
        checkboxChange={onSelectedCheckboxChange}
        placeholder="Search for team"
      />
      {userListModal && (
        <InfoModal
          hide={() => setUserListModal(false)}
          show={userListModal}
          title={"User Information"}
          listingData={userInfo}
        />
      )}
      {deleteConfirm && (
        <DeleteConFirmationModal
          show={deleteConfirm}
          title={modalConfirmTitle}
          eventHandler={removeUserHandler}
          hide={() => setDeleteConfirm(false)}
        />
      )}

      {confirmUpdateModal && (
        <UpdateUserStatusModal
          show={confirmUpdateModal}
          title={modalConfirmTitle}
          eventHandler={userStatusUpdateHandler}
          hide={() => setConfirmUpdateModal(false)}
        />
      )}
    </div>
  );
}
export default Users;
